// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.doctor-profile {
  padding: 24px;
  height: 100%;
  overflow-y: auto;
  background: linear-gradient(180deg, #ffffff 0%, #f8f9fa 100%);
}

/* 医生头部信息 */
.doctor-header {
  text-align: center;
  margin-bottom: 24px;
}

.doctor-avatar-container {
  margin-bottom: 16px;
}

.doctor-avatar {
  border: 4px solid #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: transform 0.3s ease;
  width: 140px;
  height: 140px;
  object-fit: cover;
  border-radius: 50%;
}

.doctor-avatar:hover {
  transform: scale(1.05);
}

.doctor-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.doctor-name {
  margin: 0 !important;
  color: #285C4D;
  font-weight: 600;
}

.doctor-title {
  font-size: 16px;
  color: #52c41a;
  font-weight: 500;
}

.doctor-specialty {
  font-size: 14px;
  color: #666;
}

.doctor-experience {
  font-size: 12px;
  color: #999;
  margin-top: 4px;
}

/* 状态部分 */
.status-section {
  padding: 16px;
  background: linear-gradient(135deg, #f6ffed 0%, #f0f9ff 100%);
  border-radius: 12px;
  border-left: 4px solid #52c41a;
  margin-bottom: 16px;
}

.status-text {
  display: block;
  margin-top: 4px;
}

/* 专业领域 */
.expertise-section {
  margin-bottom: 16px;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px !important;
  color: #285C4D;
  font-size: 14px;
}

.expertise-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.expertise-tag {
  border-radius: 16px;
  padding: 4px 12px;
  font-size: 12px;
  border: none;
  cursor: default;
  transition: transform 0.2s ease;
}

.expertise-tag:hover {
  transform: translateY(-1px);
}

/* 服务时间 */
.schedule-section {
  margin-bottom: 16px;
}

.schedule-info {
  padding: 12px;
  background: #fafafa;
  border-radius: 8px;
  border: 1px solid #f0f0f0;
  line-height: 1.6;
}

/* 所属机构 */
.affiliation-section {
  margin-bottom: 16px;
}

.affiliation-info {
  padding: 12px;
  background: linear-gradient(135deg, #fff7e6 0%, #fffbe6 100%);
  border-radius: 8px;
  border: 1px solid #ffe7ba;
  line-height: 1.8;
}

/* 医生格言 */
.motto-section {
  margin-bottom: 20px;
}

.doctor-motto {
  background: linear-gradient(135deg, #e6f7ff 0%, #f0f9ff 100%);
  border-left: 4px solid #285C4D;
  padding: 16px;
  border-radius: 8px;
  margin: 0 !important;
  font-size: 14px;
  line-height: 1.6;
  color: #285C4D;
  text-align: center;
}

/* 联系方式 */
.contact-section {
  margin-top: 20px;
}

.contact-btn {
  width: 100%;
  border-radius: 20px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  transition: all 0.3s ease;
}

.contact-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

/* 分割线样式 */
.ant-divider {
  margin: 16px 0;
  border-top-color: #f0f0f0;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .doctor-profile {
    padding: 20px;
  }
  
  .doctor-avatar {
  width: 120px;
  height: 120px;
  }
  
  .doctor-name {
    font-size: 20px;
  }
  
  .section-title {
    font-size: 13px;
  }
}

@media (max-width: 768px) {
  .doctor-profile {
    padding: 16px;
  }
  
  .doctor-avatar {
  width: 100px;
  height: 100px;
  }
  
  .doctor-name {
    font-size: 18px;
  }
  
  .doctor-title {
    font-size: 14px;
  }
  
  .expertise-tags {
    justify-content: center;
  }
  
  .status-section,
  .schedule-info,
  .affiliation-info,
  .doctor-motto {
    padding: 12px;
    font-size: 13px;
  }
}

/* 滚动条样式 */
.doctor-profile::-webkit-scrollbar {
  width: 4px;
}

.doctor-profile::-webkit-scrollbar-track {
  background: transparent;
}

.doctor-profile::-webkit-scrollbar-thumb {
  background: #d9d9d9;
  border-radius: 2px;
}

.doctor-profile::-webkit-scrollbar-thumb:hover {
  background: #bfbfbf;
}

/* 动画效果 */
.doctor-profile > * {
  animation: slideInLeft 0.6s ease-out;
}

@keyframes slideInLeft {
  from {
    opacity: 0;
    transform: translateX(-20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

/* Badge 样式调整 */
.ant-badge .ant-badge-status-dot {
  width: 12px;
  height: 12px;
}

/* Tag 颜色增强 */
.expertise-tag.ant-tag-blue {
  background: linear-gradient(135deg, #e6f7ff 0%, #bae7ff 100%);
  border: 1px solid #91d5ff;
  color: #285C4D;
}

.expertise-tag.ant-tag-green {
  background: linear-gradient(135deg, #f6ffed 0%, #d9f7be 100%);
  border: 1px solid #b7eb8f;
  color: #389e0d;
}

.expertise-tag.ant-tag-orange {
  background: linear-gradient(135deg, #fff7e6 0%, #ffe7ba 100%);
  border: 1px solid #ffd591;
  color: #d46b08;
}

.expertise-tag.ant-tag-purple {
  background: linear-gradient(135deg, #f0fff0 0%, #e6f9e6 100%);
  border: 1px solid #c7f1a8;
  color: #6FC232;
}
`, "",{"version":3,"sources":["webpack://./src/components/DoctorProfile.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,6DAA6D;AAC/D;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,0CAA0C;EAC1C,+BAA+B;EAC/B,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,6DAA6D;EAC7D,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,SAAS;AACT;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,8BAA8B;EAC9B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,SAAS;AACT;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,SAAS;AACT;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,6DAA6D;EAC7D,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,SAAS;AACT;EACE,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,8BAA8B;EAC9B,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA,SAAS;AACT;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA,UAAU;AACV;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA,UAAU;AACV;EACE;IACE,aAAa;EACf;;EAEA;EACA,YAAY;EACZ,aAAa;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;EACA,YAAY;EACZ,aAAa;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;;;IAIE,aAAa;IACb,eAAe;EACjB;AACF;;AAEA,UAAU;AACV;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,SAAS;AACT;EACE,oCAAoC;AACtC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,eAAe;AACf;EACE,WAAW;EACX,YAAY;AACd;;AAEA,aAAa;AACb;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,cAAc;AAChB","sourcesContent":[".doctor-profile {\n  padding: 24px;\n  height: 100%;\n  overflow-y: auto;\n  background: linear-gradient(180deg, #ffffff 0%, #f8f9fa 100%);\n}\n\n/* 医生头部信息 */\n.doctor-header {\n  text-align: center;\n  margin-bottom: 24px;\n}\n\n.doctor-avatar-container {\n  margin-bottom: 16px;\n}\n\n.doctor-avatar {\n  border: 4px solid #fff;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  transition: transform 0.3s ease;\n  width: 140px;\n  height: 140px;\n  object-fit: cover;\n  border-radius: 50%;\n}\n\n.doctor-avatar:hover {\n  transform: scale(1.05);\n}\n\n.doctor-info {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.doctor-name {\n  margin: 0 !important;\n  color: #285C4D;\n  font-weight: 600;\n}\n\n.doctor-title {\n  font-size: 16px;\n  color: #52c41a;\n  font-weight: 500;\n}\n\n.doctor-specialty {\n  font-size: 14px;\n  color: #666;\n}\n\n.doctor-experience {\n  font-size: 12px;\n  color: #999;\n  margin-top: 4px;\n}\n\n/* 状态部分 */\n.status-section {\n  padding: 16px;\n  background: linear-gradient(135deg, #f6ffed 0%, #f0f9ff 100%);\n  border-radius: 12px;\n  border-left: 4px solid #52c41a;\n  margin-bottom: 16px;\n}\n\n.status-text {\n  display: block;\n  margin-top: 4px;\n}\n\n/* 专业领域 */\n.expertise-section {\n  margin-bottom: 16px;\n}\n\n.section-title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 12px !important;\n  color: #285C4D;\n  font-size: 14px;\n}\n\n.expertise-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.expertise-tag {\n  border-radius: 16px;\n  padding: 4px 12px;\n  font-size: 12px;\n  border: none;\n  cursor: default;\n  transition: transform 0.2s ease;\n}\n\n.expertise-tag:hover {\n  transform: translateY(-1px);\n}\n\n/* 服务时间 */\n.schedule-section {\n  margin-bottom: 16px;\n}\n\n.schedule-info {\n  padding: 12px;\n  background: #fafafa;\n  border-radius: 8px;\n  border: 1px solid #f0f0f0;\n  line-height: 1.6;\n}\n\n/* 所属机构 */\n.affiliation-section {\n  margin-bottom: 16px;\n}\n\n.affiliation-info {\n  padding: 12px;\n  background: linear-gradient(135deg, #fff7e6 0%, #fffbe6 100%);\n  border-radius: 8px;\n  border: 1px solid #ffe7ba;\n  line-height: 1.8;\n}\n\n/* 医生格言 */\n.motto-section {\n  margin-bottom: 20px;\n}\n\n.doctor-motto {\n  background: linear-gradient(135deg, #e6f7ff 0%, #f0f9ff 100%);\n  border-left: 4px solid #285C4D;\n  padding: 16px;\n  border-radius: 8px;\n  margin: 0 !important;\n  font-size: 14px;\n  line-height: 1.6;\n  color: #285C4D;\n  text-align: center;\n}\n\n/* 联系方式 */\n.contact-section {\n  margin-top: 20px;\n}\n\n.contact-btn {\n  width: 100%;\n  border-radius: 20px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  transition: all 0.3s ease;\n}\n\n.contact-btn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n/* 分割线样式 */\n.ant-divider {\n  margin: 16px 0;\n  border-top-color: #f0f0f0;\n}\n\n/* 响应式设计 */\n@media (max-width: 1200px) {\n  .doctor-profile {\n    padding: 20px;\n  }\n  \n  .doctor-avatar {\n  width: 120px;\n  height: 120px;\n  }\n  \n  .doctor-name {\n    font-size: 20px;\n  }\n  \n  .section-title {\n    font-size: 13px;\n  }\n}\n\n@media (max-width: 768px) {\n  .doctor-profile {\n    padding: 16px;\n  }\n  \n  .doctor-avatar {\n  width: 100px;\n  height: 100px;\n  }\n  \n  .doctor-name {\n    font-size: 18px;\n  }\n  \n  .doctor-title {\n    font-size: 14px;\n  }\n  \n  .expertise-tags {\n    justify-content: center;\n  }\n  \n  .status-section,\n  .schedule-info,\n  .affiliation-info,\n  .doctor-motto {\n    padding: 12px;\n    font-size: 13px;\n  }\n}\n\n/* 滚动条样式 */\n.doctor-profile::-webkit-scrollbar {\n  width: 4px;\n}\n\n.doctor-profile::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.doctor-profile::-webkit-scrollbar-thumb {\n  background: #d9d9d9;\n  border-radius: 2px;\n}\n\n.doctor-profile::-webkit-scrollbar-thumb:hover {\n  background: #bfbfbf;\n}\n\n/* 动画效果 */\n.doctor-profile > * {\n  animation: slideInLeft 0.6s ease-out;\n}\n\n@keyframes slideInLeft {\n  from {\n    opacity: 0;\n    transform: translateX(-20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n/* Badge 样式调整 */\n.ant-badge .ant-badge-status-dot {\n  width: 12px;\n  height: 12px;\n}\n\n/* Tag 颜色增强 */\n.expertise-tag.ant-tag-blue {\n  background: linear-gradient(135deg, #e6f7ff 0%, #bae7ff 100%);\n  border: 1px solid #91d5ff;\n  color: #285C4D;\n}\n\n.expertise-tag.ant-tag-green {\n  background: linear-gradient(135deg, #f6ffed 0%, #d9f7be 100%);\n  border: 1px solid #b7eb8f;\n  color: #389e0d;\n}\n\n.expertise-tag.ant-tag-orange {\n  background: linear-gradient(135deg, #fff7e6 0%, #ffe7ba 100%);\n  border: 1px solid #ffd591;\n  color: #d46b08;\n}\n\n.expertise-tag.ant-tag-purple {\n  background: linear-gradient(135deg, #f0fff0 0%, #e6f9e6 100%);\n  border: 1px solid #c7f1a8;\n  color: #6FC232;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
